import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MaintenanceInfoComponent } from './components/maintenance-info/maintenance-info.component';

@NgModule({
    imports: [CommonModule, FormsModule, TranslateModule],
    declarations: [MaintenanceInfoComponent],
    exports: [MaintenanceInfoComponent],
    providers: [],
})
export class MaintenanceInfoModule {}
